import fetch ,{getBlob2}from '../utils/fetch';


export function getEvaluateList(params) {
  return fetch({
    method: 'POST',
    url: '/evaluate/getEvaluateList',
    data:params
  })
}

export function getListCondition(params) {
  return fetch({
    method: 'GET',
    url: '/evaluate/getListCondition',
    params
  })
}


export function getConfigListCondition(params) {
  return fetch({
    method: 'GET',
    url: '/evaluate/getConfigListCondition',
    params
  })
}

export function getConfigList(params) {
  return fetch({
    method: 'GET',
    url: '/evaluate/getConfigList',
    params
  })
}

export function changeConfigState(params) {
  return fetch({
    method: 'POST',
    url: '/evaluate/changeConfigState',
    data:params
  })
}
export function getEvaluateModuleDetail(params) {
  return fetch({
    method: 'GET',
    url: '/evaluate/getEvaluateModuleDetail',
    params
  })
}
export function exportEvaluateList(params) {
  return getBlob2({
    method: 'POST',
    url: '/evaluate/exportEvaluateList',
    data:params
  })
}

export function getExportEvaluateCount(params) {
  return fetch({
    method: 'POST',
    url: '/evaluate/getExportEvaluateCount',
    data:params
  })
}
export function toggleDisplay(params) {
  return fetch({
    method: 'POST',
    url: '/evaluate/showOrHide',
    data:params
  })
}

/**
 * 管家说:管家列表查询接口
 * 
 */

export function getZoEmp(params) {
  return fetch({
    method: 'GET',
    url: '/stewarTalk/getpZoEmp',
    params
  })
}
/**
 * 管家说:审核状态枚举查询接口
 * 
 */

export function getAuditStatus(params) {
  return fetch({
    method: 'POST',
    url: '/stewarTalk/auditStatus',
    data:params
  })
}
/**
 * 管家说:表格数据查询接口
 * 
 */

export function getsteWarList(params) {
  return fetch({
    method: 'POST',
    url: '/stewarTalk/select',
    data:params
  })
}
/**
 * 管家说:数据审核接口
 * 
 */

export function updateStatus(params) {
  return fetch({
    method: 'POST',
    url: '/stewarTalk/updateStatus',
    data:params
  })
}


